/***
 * 创建人：李珊
 * 时间：2020-11-27
 * 描述: 控制台页面
 * 使用说明:
 * 更新说明:
 */
import { Component, OnInit } from '@angular/core';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../kms.service';
import { SwTabService } from 'src/app/librarys/serves/public/sw-tab.service';
import { SwRouteguardService } from 'src/app/librarys/serves/sw-routeguard.service';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { Router } from '@angular/router';
import { KmsEnum } from '../../serves/kms-enum';

@Component({
  selector: 'app-kms-console',
  templateUrl: './kms-console.component.html',
  styleUrls: ['./kms-console.component.css']
})
export class KmsConsoleComponent implements OnInit {
  // 用户角色
  userRole = '';
  // 当前用户id
  userId:string = '';
  chartBarOne: any; // 资源形态统计
  chartBarTwo: any;
  chartBarThe: any;
  chartBarFor: any;
  chartBarFiv: any;
  chartBook: any; // 资源形态统计
  baronemode: string = 'pie'; // 
  bartwomode: string = 'bar'; // 资源类型模式
  barthemode: string = 'line'; // 资源类型模式
  barformode: string = 'bar'; // 资源类型模式
  barfivmode: string = 'pie';
  selectedTool: string = 'tool';
  selectedToolModel: string = 'pie';
  materialTypeData:any = {};
  markData:any = {};
  ocrData:any = {};
  docTypeData: Array<any> = [
    { value: 0, name: '图书', type: 'book' },
    { value: 0, name: '期刊论文', type: 'journal' },
    { value: 0, name: '学位论文', type: 'paper' },
    { value: 0, name: '文物', type: 'ancientBook' },
    { value: 0, name: '其他', type: 'other' }
  ]; // 资源类型
  themeData: Array<any> = []; // 主题类型
  periodicalData: Array<any> = []// 期刊类型
  entityData: Array<any> = []// 实体类型
  instanceTotal = 0;
  pubishedNum = 0;
  productionData: Array<any> = []// 实体类型
  bookData: Array<any> = [];
  bookData1: Array<any> = [];
  colors = ['#f39323', '#b59275', '#fac581', '#f5e2cf', '#cdcdcd', '#FAC231', '#7673A7','#91AD15','#D1C80D','#DD6131']; // 自定义颜色数组
  editInstanceNum = 0;
  checkInstanceNum = 0;
  myInstanceTotal = 0;
  relatedTotal = 0;
  isAdmin = true;

  constructor(
    private tabService:SwTabService,
    private User: GetUserModelService, //获取用户服务
    private rot: SwRouteguardService,
    private router: Router,
    private kmsService: KmsService,
    private box: SwMassageBoxService,
    private jwt:SwJwtService
  ) { }

  ngOnInit() {
    //获取tab菜单
    let menuList = this.rot.getMenus();
    let path = '/oa/portal';
    let index = menuList.findIndex(v=>v.path == path)
    if(index != -1){
      this.tabService.closeUrl(path, true);
    }
    // 获取用户id
    let user = this.User.getUser();
    this.userId = user['userId'];
    // 获取用户角色
    this.userRole = this.jwt.getToken('userRole');
    // 素材类型统计
    this.materialStatistic();
    // 图像标记统计
    this.imageMarkStatistic();
    // 已OCR识别统计
    this.queryMaterialList();
    // 文档资源类型统计
    this.materialTypeStatistic();
    // 资源研究主题统计
    this.materiaThemeStatistic();
    // 图书统计
    this.bookStatistic();
    // 论文发表时间统计
    this.paperPublishTimeStatistic();
    // 查询三元组总数
    this.relatedTotalStatistic();
    // 实体分类统计
    this.instanceClassifiStatistic();
    // 知识生产任务统计
    this.instanceProdTaskStatistic();
  }

  // 素材类型统计
  materialStatistic(){
    this.kmsService.materialStatistic({}).subscribe(
      data => {
        if (data["code"] == '200') {
          const obj = {
            all: 0,
            picture: 0,
            document: 0,
            audio: 0,
            video: 0,
            link: 0
          }
          const keys = Object.keys(data.data);
          keys.forEach((e,i) => {
            obj.all += data.data[e];
            if(e == 'FILE_TYPE_DOCUMENT'){
              obj.document = data.data[e];
            }
            if(e == 'FILE_TYPE_PICTURE'){
              obj.picture = data.data[e];
            }
            if(e == 'FILE_TYPE_AUDIO'){
              obj.audio = data.data[e];
            }
            if(e == 'FILE_TYPE_VIDEO'){
              obj.video = data.data[e];
            }
            if(e.indexOf('KGS_LINKDATA') != -1){
              obj.link += data.data[e];  
            }
          });
          this.materialTypeData = obj;
        }
      }
    )
  }

  // 图像标记统计
  imageMarkStatistic(){
    let params = {
      "currentUserId": this.userId,
      "currentUserRole": this.getUserRoleCode()
    }
    this.kmsService.imageMarkStatistic(params).subscribe(
      data => {
        if (data["code"] == '200') {
          this.markData.remark = data.data.remark;
          this.markData.total = data.data.total;
          if(this.getUserRoleCode() !== 'admin'){
            this.kmsService.imageMarkStatistic({}).subscribe(
              data => {
                if (data["code"] == '200') {
                  this.markData.remarkTotal = data.data.remark;
                }
              }
            )
          }else{
            this.markData.remarkTotal = this.markData.remark;
          }
        }
      }
    )
  }

  // 已OCR识别统计
  queryMaterialList(){
    const params = {
      current: 1,
      size: 10,
      textExtractStatus: 3
    }
    this.kmsService.queryMaterialList(params).subscribe(
      data => {
        if (data["code"] == '200') {
          this.ocrData = data.data;
        }
      }
    )
  }

  // 文档资源类型统计
  materialTypeStatistic(){
    this.kmsService.materialTypeStatistic({}).subscribe(
      data => {
        if (data["code"] == '200') {
          let d = data.data;
          this.docTypeData.forEach(v=>{
            v.value = d[v.type];
          })
          this.setChartMode(this.baronemode); // 初始化第一个图表
        }
      }
    )
  }

  // 资源研究主题统计
  materiaThemeStatistic(){
    this.kmsService.materiaThemeStatistic({}).subscribe(
      data => {
        if (data["code"] == '200') {
          let d = data.data.slice(1);
          this.themeData = []
          d = d.sort((a,b)=>{
            return b.value - a.value;
          });
          let other = 0;
          d.forEach((e,i) => {
            if(i < 9){
              this.themeData.push({
                name: e.tagname,
                value: e.count,
              });
            }else{
              other += e.count;
            }
          });
          this.themeData.push({
            name: '其他',
            value: other,
          });
          this.setChart1Mode(this.bartwomode); // 初始化第二个图表
        }
      }
    )
  }

  // 图书统计
  bookStatistic(){
    this.kmsService.bookStatistic({}).subscribe(
      data => {
        if (data["code"] == '200') {
          // 获取出版年代统计数据
          let publicationTime = data.data.publicationTime;
          let keys = Object.keys(publicationTime);
          keys.forEach((e,i) => {
            if(e != '未知'){
              this.bookData1.push({
                name: e.replace('年',''),
                value: publicationTime[e]
              });
            }
          });
          // 获取出版社统计数据
          let publishingHouse = data.data.publishingHouse;
          let keys1 = Object.keys(publishingHouse);
          let arr = [];
          keys1.forEach((e,i) => {
            if(e != '未知'){
              arr.push({
                name: e,
                value: publishingHouse[e]
              });
            }
          });
          arr = arr.sort((a,b)=>{
            return b.value - a.value;
          });
          let other = 0;
          arr.forEach((e,i) => {
            if(i < 30){
              this.bookData.push({
                name: e.name,
                value: e.value
              });
            }else{
              other += e.value;
            }
          });
          this.bookData.push({
            name: '其他',
            value: other
          })
          // 默认加载出版社统计数据
          this.getBook();
        }
      }
    )
  }

  // 论文发表时间统计
  paperPublishTimeStatistic(){
    this.kmsService.paperPublishTimeStatistic({}).subscribe(
      data => {
        if (data["code"] == '200') {
          let keys = Object.keys(data.data);
          keys.forEach((e,i) => {
            if(e != '未知'){
              this.periodicalData.push({
                name: e.replace('年',''),
                value: data.data[e]
              });
            }
          });
          this.setChart2Mode(this.barthemode);
        }
      }
    )
  }

  // 查询三元组总数
  relatedTotalStatistic(){
    this.kmsService.relatedTotalStatistic({}).subscribe(
      data => {
        if (data["code"] == '200') {
          this.relatedTotal = data.data.relatedTotal;
        }
      }
    )
  }

  // 实体分类统计
  instanceClassifiStatistic(){
    this.kmsService.instanceClassifiStatistic({}).subscribe(
      data => {
        if (data["code"] == '200') {
          let d = data.data.sort((a,b)=>{
            return b.count - a.count;
          });
          d.forEach(e => {
            this.entityData.push({
              name: e.conceptName,
              value: e.count,
            });
            this.instanceTotal += e.count;
          });
          this.setChart3Mode(this.barformode); // 初始化第二个图表
        }
      }
    )
  }

  // 知识生产任务统计
  instanceProdTaskStatistic(){
    let params = {
      "currentUserId": this.userId,
      "currentUserRole": this.getUserRoleCode()
    }
    this.kmsService.instanceProdTaskStatistic(params).subscribe(
      data => {
        if (data["code"] == '200') {
          let keys = Object.keys(data.data);
          keys.forEach((e,i) => {
            if(e == '已发布'){
              this.pubishedNum = data.data[e];
            }
            if(e == '待编辑'){
              this.editInstanceNum = data.data[e];
            }
            if(e == '待质检'){
              this.checkInstanceNum = data.data[e];
            }
            if(e !== 'all'){
              this.myInstanceTotal += data.data[e];
            }
          });
          let arr1 = [];
          let arr = ['待指派','待编辑', '待分配质检', '待质检', '待发布', '已发布'];
          arr.forEach((e,i) => {
            arr1.push({
              name: e,
              value: data.data[e] ? data.data[e] : 0
            });
          });
          this.productionData = arr1;
          this.setChart4Mode(this.barfivmode); // 初始化第二个图表
        }
      }
    )
    if(this.userRole !== '知识编辑' && this.userRole!== '知识质检'){
      this.isAdmin = true;
    }
    else{
      this.isAdmin = false;
    }
  }

  getUserRoleCode(){
    if(this.userRole !== '知识编辑' && this.userRole!== '知识质检'){
      return 'admin';
    }else if(this.userRole == '知识编辑'){
      return 'editor';
    }else if(this.userRole == '知识质检'){
      return 'checker';
    }
  }


  // 通过我的任务进入实体管理、图像标记页面
  toListPage(module, approvalStatus){
    const data = {
      approvalStatus: approvalStatus
    }
    if(module == 'instance'){
      this.router.navigate(["/kms/InstanceQuery"], {
        queryParams: { Title: "实体管理", selectedData: JSON.stringify(data) }
      });
    }else{
      this.router.navigate(["/kms/ImgMarkQuery"], {
        queryParams: { Title: "图像标记", selectedData: JSON.stringify(data) }
      });
    }
  }
  // 图书统计图表
  getBook() {
    if(this.selectedTool == 'tool'){
      this.chartBook = this.getCommonConfig('pie', this.bookData);
    }else{
      this.chartBook = this.getCommonConfig('line', this.bookData1);
    }
    // this.chartBook = {
    //   grid: {
    //     left: '20%',  // 增加左侧空白区域
    //     right: '10%', // 增加右侧空白区域
    //     bottom: '10%', // 增加底部空白区域
    //   },
    //   xAxis: {
    //     type: 'value',  // 将 x 轴改为数值轴
    //     axisLine: {
    //       show: false // 去掉 x 轴的起始刻度线
    //     }
    //   },
    //   yAxis: {
    //     type: 'category',  // 将 y 轴改为类别轴
    //     data: this.selectedTool == 'tool' ? this.bookData.map(v => v.name) : this.bookData1.map(v => v.name),
    //   },
    //   series: [
    //     {
    //       data: this.selectedTool == 'tool' ? this.bookData.map(v => v.value) : this.bookData1.map(v => v.value),
    //       type: 'bar',
    //       barWidth: 10,  // 设置每个柱子的宽度为30
    //       label: {
    //         show: true,               // 显示数值标签
    //         position: 'right',        // 将标签位置设置为数据点的右侧
    //         color: '#f39323',         // 标签文本的颜色
    //         fontSize: 12              // 可选：调整标签文本的大小
    //       },
    //       itemStyle: {
    //         color: '#f39323'          // 设置柱状图的颜色为黄色
    //       }
    //     }
    //   ]
    // }    
  }
  // 切换图书统计
  selectTool(tool: string) {
    this.selectedToolModel = 'pie';
    this.selectedTool = tool;
    this.getBook();  // 切换后重新渲染图表
  }
  selectToolTable() {
    this.selectedToolModel = 'table';
  }
  chartConfigs = {
    pie: (data) => this.getCommonConfig('pie', data),
    line: (data) => this.getCommonConfig('line', data),
    bar: (data) => this.getCommonConfig('bar', data)
  };
  setChartMode(mode: string) {
    this.baronemode = mode;
    this.chartBarOne = this.chartConfigs[mode](this.docTypeData);
  }
  setChart1Mode(mode: string) {
    this.bartwomode = mode;
    this.chartBarTwo = this.chartConfigs[mode](this.themeData);
  }
  setChart2Mode(mode: string) {
    this.barthemode = mode;
    this.chartBarThe = this.chartConfigs[mode](this.periodicalData);
  }
  setChart3Mode(mode: string) {
    this.barformode = mode;
    this.chartBarFor = this.chartConfigs[mode](this.entityData);
  }
  setChart4Mode(mode: string) {
    this.barfivmode = mode;
    this.chartBarFiv = this.chartConfigs[mode](this.productionData);
  }

  getCommonConfig(type: string, data): any {
    const commonTooltip = {
        trigger: type === 'item' ? 'item' : 'axis'
    };

    const commonYAxis = {
        type: 'value',
        axisLine: {
            show: false // 去掉 y 轴的起始刻度线
        }
    };

    const seriesConfig = {
      pie: {
          type: 'pie',
          radius: '50%',
          data,
          label: {
            formatter: '{b}: {c} ({d}%)',
            color: 'black' // 将所有标签的颜色设置为黑色
          },
          itemStyle: {
            color: (params) => this.getColor(params.dataIndex)
          },
          emphasis: {
              itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
          }
      },
      line: {
          type: 'line',
          data: data.map(v => v.value),
          lineStyle: {
              color: '#f39323'  // 设置折线颜色为黄色
          },
          itemStyle: {
              color: '#f39323'          
          },
          label: {
              show: true,               // 显示数值标签
              position: 'top',          // 将标签位置设置为数据点的顶部
              color: '#f39323',         // 标签文本的颜色
              fontSize: 12              // 可选：调整标签文本的大小
          }
      },
      bar: {
          data: data.map(v => v.value),
          type: 'bar',
          label: {
              show: true,               // 显示数值标签
              position: 'top',          // 将标签位置设置为数据点的顶部
              color: '#f39323',         // 标签文本的颜色
              fontSize: 12              // 可选：调整标签文本的大小
          },
          itemStyle: {
              color: '#f39323'          // 设置柱状图的颜色为黄色
          },
          barWidth: 10,  // 设置每个柱子的宽度为30
      }
    };

    return {
        tooltip: commonTooltip,
        xAxis: type !== 'pie' ? {
            type: 'category',
            data: data.map(v => v.name),
        } : undefined,
        yAxis: type !== 'pie' ? commonYAxis : undefined,
        series: [seriesConfig[type]]
    };
  }

  // 获取颜色
  getColor(index: number): string {
    return index < this.colors.length ? this.colors[index] : this.getRandomColor();
  }

  // 生成随机颜色
  getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
}
